import { type SupplierListItem } from '@choco-admin/types';

export type FormMode = 'create' | 'edit';

export enum TabType {
  PROFILE = 'PROFILE',
  ORDER_PREFERENCES = 'ORDER_PREFERENCES',
  CATALOG = 'CATALOG',
  DELIVERY_ZONES = 'DELIVERY_ZONES',
  TEAM = 'TEAM',
  SETTINGS = 'SETTINGS',
  NOTIFICATIONS = 'NOTIFICATIONS',
}

export const tabLabels: Record<TabType, string> = {
  PROFILE: 'Profile',
  ORDER_PREFERENCES: 'Order Preferences',
  CATALOG: 'Catalog',
  DELIVERY_ZONES: 'Delivery Zones',
  TEAM: 'Team',
  SETTINGS: 'Settings',
  NOTIFICATIONS: 'Notifications',
};

export interface TabProps {
  mode: FormMode;
  supplier?: SupplierListItem;
}

export interface SupplierFormData {
  // Profile
  name: string;
  description?: string;
  primaryCategory: string;
  secondaryCategories?: string[];
  deliveryFee?: string;
  minimumOrderValue?: string;
  minimumOrderCurrency?: string;

  // Order preferences
  allowCustomProducts: boolean;
  mandatoryCustomerNumber: boolean;
  mandatoryDeliveryDate: boolean;
  enableProductComments: boolean;
  allowFractionalUnits: boolean;
  allowOnlyOneVariant: boolean;
  sortBy: 'alphabetical' | 'orderGuide';

  // Catalog
  supplierDefaultSubCatalog: string;
  displayInMarketplace: boolean;
  displayToCustomers: boolean;
  supplierHideMyPrice: boolean;

  // Delivery settings
  cutoffType: 'strict' | 'flexible';
  deliveryDays: string[];
  cutoffTimes: Record<string, string>;
}
